import * as React from 'react';
import * as styles from './styles.css';

import { ArticleHeading3, ArticleParagraph2 } from '@cian/ui-kit';

export interface IFooterActionProps {
  title: string;
  subTitle?: string;
  action: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

export function FooterAction({ title, subTitle, action, ref }: IFooterActionProps): React.JSX.Element {
  return (
    <div ref={ref} className={styles['container']}>
      <div className={styles['text-content']}>
        <ArticleHeading3>{title}</ArticleHeading3>
        <ArticleParagraph2>{subTitle}</ArticleParagraph2>
      </div>
      {action}
    </div>
  );
}
